"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiBreadcrumbs = void 0;
var colors_1 = require("../colors");
exports.MuiBreadcrumbs = {
    styleOverrides: {
        root: {
            li: {
                a: {
                    color: colors_1.tannerGray[700],
                    svg: {
                        verticalAlign: 'sub',
                        marginRight: '3px',
                        color: colors_1.tannerGray[600],
                        height: '17px',
                    },
                    '&:hover': {
                        color: colors_1.tannerBlack,
                        svg: {
                            color: colors_1.tannerBlack,
                        },
                    },
                    '&:active': {
                        color: colors_1.tannerGray[800],
                        svg: {
                            color: colors_1.tannerGray[800],
                        },
                    },
                },
                p: {
                    color: colors_1.tannerGray[700],
                },
            },
        },
    },
};
//# sourceMappingURL=MuiBreadcrumbs.js.map